import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouWillLearn } from './components/WhatYouWillLearn';
import { TransformationSection } from './components/TransformationSection';
import { TomosGrid } from './components/TomosGrid';
import { WhyTrustUs } from './components/WhyTrustUs';
import { BonosSection } from './components/BonosSection';
import { TestimonialsBlock } from './components/TestimonialsBlock';
import { Guarantee } from './components/Guarantee';
import { StackValue } from './components/StackValue';
import { PricingCards } from './components/PricingCards';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { SaleNotifications } from './components/SaleNotifications';
import { TopBar } from './components/TopBar';
const META_PIXEL_ID = '1715709876227103';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Avoid double-initializing the pixel
    if (w.fbq) return;
    // Set up the fbq stub queue (official Meta Pixel bootstrap)
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    w.fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the fbevents script safely into <head>. The official snippet
    // inserts before the first <script> tag, but in some environments no
    // such tag exists yet — appending to <head> avoids the parentNode crash.
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const parent = document.head || document.body;
    if (parent) parent.appendChild(t);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-surface flex flex-col relative w-full overflow-x-hidden font-inter" data-id="element-0">
      {/* noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <TopBar data-id="element-3" />

      <main className="flex-1" data-id="element-4">
        <Hero data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <AgitationSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <WhatYouWillLearn data-id="element-9" />
        <TomosGrid data-id="element-10" />
        <TransformationSection data-id="element-11" />
        <WhyTrustUs data-id="element-12" />
        <BonosSection data-id="element-13" />
        <TestimonialsBlock data-id="element-14" />
        <Guarantee data-id="element-15" />
        <StackValue data-id="element-16" />
        <PricingCards data-id="element-17" />
        <FAQ data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>

      <Footer data-id="element-20" />

      {/* Conversion Features */}
      <StickyCTA data-id="element-21" />
      <ExitIntentPopup data-id="element-22" />
      <SaleNotifications data-id="element-23" />
    </div>;
}